import { render, staticRenderFns } from "./editcargo.vue?vue&type=template&id=5fdfbb85&scoped=true&"
import script from "./editcargo.vue?vue&type=script&lang=js&"
export * from "./editcargo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fdfbb85",
  null
  
)

export default component.exports